<div class="content">
  <div class="component-header">
    <h3 class="pcl-tagline highlight-line">404</h3>
    <h1>Page not found</h1>
  </div>
  <h4>Oops! Something went wrong. We can't find the page you're looking for.</h4>
</div>
